import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Str from "shared/components/Str";

const NavBarLink = ({ isSelected, IconComponent, text, path }) => (
	<a
		href={path}
		className="navbar-link"
	>
		<div className="navbar-link-icon-container" >
			<IconComponent
				className={classnames("navbar-icon", {
					"navbar-icon-selected": isSelected,
				})}
				width={24}
				height={24}
			/>
			<div
				className={classnames("navbar-underline", {
					"navbar-underline-selected": isSelected,
				})}
			/>
		</div>
		<span className="navbar-text">
			<Str>{text}</Str>
		</span>
	</a>
);

NavBarLink.defaultProps = {
	isSelected: false,
};

NavBarLink.propTypes = {
	isSelected: PropTypes.bool,
	IconComponent: PropTypes.node.isRequired,
	text: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
};

export default NavBarLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/NavBarLink.jsx